<div mat-dialog-title>
    Verify OTP
</div>
<div mat-dialog-content>
    <form [formGroup]="verification_form">
        <div class="row" style="justify-content: center;">
            <div class="col-md-12 mb-2">
                <span [ngClass]="{'success-text':verification_checking,'failer-text':!verification_checking}" class="">
                    {{message}}
                </span>
            </div>
            <div class="col-md-12 mb-2 col-sm-12 ">
                <app-mask-password [form_group]="verification_form" [form_control]="'otp'" [placeholder]="'EXTRA.enter_OTP'|translate" ></app-mask-password>
                <!-- <div style="width: 190px;
                                  overflow: hidden; border-radius: .25rem;">
                    <div style="left: 0;
                                      position: sticky;">
                        <input formControlName="otp" *ngIf="valid_OTP" class="form-control valid-input " type="text"
                            minlength="4" maxlength="4" required />
                        <input formControlName="otp" *ngIf="!valid_OTP" class="form-control invalid-input " type="text"
                            minlength="4" maxlength="4" required />
                    </div>
                </div> -->
            </div>
            <div class="col-md-12 form-group text-left col-sm-12 ">
                <span class="verification-code-text">
                    Didn't receive verification code?
                </span>
                <button type="button" style="margin-top: -2px; font-size: 14px !important;text-decoration: underline;
                font-weight: 500; " (click)="resendOTP($event)" class="btn p-0 link"
                    [disabled]="timer >= 1 && otp_resend <= 3"
                    [ngClass]="{'pointer-events-none':timer >= 1 && otp_resend <= 3}">
                    Resend
                </button>
                <span style="font-size: 12px;" *ngIf="timer">
                    ({{ timer }} s)
                </span>
            </div>
        </div>

    </form>
</div>
<div mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>
    <button style="min-width: 5rem;" class="ml-auto btn-sm  blob-btn-cancel btn mx-1 mx-1 tallite-action"
        (click)="close()">
        {{ 'BTN.close' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 5rem;" (click)="verifyOTP()"
        class="blob-btn float-right btn   mx-1 float-right btn-sm tallite-action" type="submit">
        {{ 'BTN.submit' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</div>